<script setup lang="ts">
import { useFeatureIndicator } from '~/composables/useFeatureIndicator'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { IFeaturedMenuKey } from '~/types/featured.type'
import ExIndicator from '~/ui/Indicator/ExIndicator.vue'
import BcSearchInput from '~/ui/Input/BcSearchInput.vue'

const { changeShowModal } = useModal()

interface IProps {
  showSideBar: boolean;
}

const props = defineProps<IProps>()

defineEmits([ 'update:showSideBar' ])

const { partFeaturedMap } = useFeatureIndicator(IFeaturedMenuKey.SIDEBAR)

const showIndicator = computed(() => {
  return !props.showSideBar && partFeaturedMap.value?.size
})
</script>

<template>
  <nav class="mobile-top-nav flex w-full items-center gap-x-2 bg-background px-2 pb-2">
    <NuxtLink
      :to="routes.getRootPage()"
      class="mr-auto"
    >
      <img
        :src="`${IMAGE_BASE_URL}/logo/logo_mainnet_mobile.png`"
        alt="nexon scanner"
        width="32"
        height="32"
      >
    </NuxtLink>
    <BcSearchInput
      class="w-full"
      readonly
      @click="changeShowModal"
      type="general"
    />
    <button
      class="relative ml-auto w-8 text-primary"
      @click="$emit('update:showSideBar')"
    >
      <FontAwesomeIcon :icon="showSideBar ? 'times' : 'bars'" />
      <ExIndicator
        v-if="showIndicator"
        class="absolute right-0 top-0"
      />
    </button>
  </nav>
</template>

<style scoped>
.mobile-top-nav {
  /* iOS safe area 대응 - 상단 노치/다이내믹 아일랜드/Liquid Glass 영역 */
  /* safe area 만큼 padding-top 추가 + 기존 8px */
  padding-top: calc(env(safe-area-inset-top, 0px) + 8px);
  /* 최소 높이를 safe area + 기존 48px로 설정해서 배경색이 확장되도록 함 */
  min-height: calc(env(safe-area-inset-top, 0px) + 48px);
}
</style>